<template>
  <Modal
    :show="showModal && !showScheduleMeetingReminderModal"
    size="sm"
    :blur-backdrop="false"
    :zIndex="10070"
    @close="closeModal"
    :show-close-button="false"
  >
    <template #default>
      <div class="modal-body-content">
        <div class="confirmation-content">
          <div class="icon-wrapper">
            <Icon icon="mdi:calendar-clock" class="calendar-icon" />
          </div>
          <div class="text-content">
            <h6 class="title">Do you want to schedule a reminder follow-up?</h6>
            <p class="subtitle">
              Set a quick reminder to schedule your important follow-up appointment.
            </p>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="modal-footer-actions">
        <Button variant="secondary" @click="closeModal">No</Button>
        <Button variant="primary" @click="confirm">Confirm</Button>
      </div>
    </template>
  </Modal>

  <ScheduleMeetingReminderModal
    v-if="showScheduleMeetingReminderModal"
    :selected-meeting="selectedMeeting"
    @close-schedule-meeting-reminder-modal="closeScheduleMeetingReminderModal"
  />
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Icon } from "@iconify/vue";
import { Button, Modal } from "@/components/ui";
import ScheduleMeetingReminderModal from "@/components/meeting/ScheduleMeetingReminderModal.vue";

interface SelectedMeeting {
  id: string;
  title: string;
  duration: number;
  meetingDateTime: string;
  guestEmails?: string[];
  meetingURL?: string;
  contactId: string;
}

interface Props {
  selectedMeeting?: SelectedMeeting;
}

defineProps<Props>();

const emit = defineEmits<{
  closeReminderFollowupModal: [];
}>();

const showModal = ref(true);
const showScheduleMeetingReminderModal = ref(false);

const closeModal = () => {
  emit("closeReminderFollowupModal");
};

const confirm = () => {
  showScheduleMeetingReminderModal.value = true;
};

const closeScheduleMeetingReminderModal = () => {
  showScheduleMeetingReminderModal.value = false;
  closeModal();
};
</script>

<style scoped>
.modal-body-content {
  padding: 28px;
}

.confirmation-content {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.icon-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  background: #3e3efe;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.calendar-icon {
  font-size: 24px;
  color: #ffffff;
}

.text-content {
  flex: 1;
}

.title {
  font-weight: 600;
  font-size: 15px;
  color: #1f2937;
  margin: 0 0 6px 0;
  line-height: 1.4;
}

.subtitle {
  font-weight: 400;
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

.modal-footer-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
}

.modal-footer-actions .ui-button {
  min-width: 100px;
}
</style>
